import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import {
  Router,
  NavigationCancel
} from '@angular/router';
import { constants } from 'src/app/constants';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/do';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  constructor(
    private router?: Router) {
      // construtor
  }
  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {
    const token = constants.access_token;
    const changedReq = req.clone(
      {
        setHeaders: {
        Authorization: 'Bearer ' + token
        },
      }
    );
    return next.handle(changedReq).do((event) => {
      // do nothing
    }, (err) => {
      if (err instanceof HttpErrorResponse &&
        err.status === 401) {
        if (err.error) {
          let errorObj = err.error; 
          // Parsing is failing due some of cases value is returned as string
          if (typeof errorObj === 'string') {
            errorObj = JSON.parse(errorObj);
          }
          if (errorObj.errors &&
            errorObj.errors[0] &&
            errorObj.errors[0].code === 37355
          ) {
            // Permission denied
            console.log('Unauthorized: '
              + errorObj.errors[0].code + '-' +
              errorObj.errors[0].message);
            return;
          }
        }
        constants.access_token = "";
        // naviagation is not working already other navigation is in progress
        this.router.navigate(['/login']);
        // return Observable.throw(new NavigationCancel(4, '', ''));
      }
    })
  }
}
